import React from "react";
import feature from "../assets/feature.png";

export default function Features() {
  return (
    <div className="max-w-[1240px] mx-auto bg-[#FFFFFF] grid grid-cols-1 md:grid-cols-2 gap-8 p-4">
      <div className="flex justify-center md:justify-start">
        <img src={feature} alt="feature illustration" className="w-full md:w-3/4 h-auto" />
      </div>
      <div className="flex flex-col justify-center">
        <h1 className='text-[#050A30] font-bold text-2xl md:text-4xl'>What is TrustForge?</h1>
        <p className="text-[#1E1E1E] text-lg md:text-2xl mt-4">TrustForge is the platform that certifies your documents and processes swiftly and effortlessly in a secure blockchain environment.</p>
        <p className="text-lg md:text-2xl mt-6">We ensure the authenticity of your information by generating traceable and immutable digital evidence through document and process tokenization.</p>
        <p className="text-lg md:text-2xl mt-6">Elevating trust and security with digital certification. Ensure your documents stay immutable and verifiable.</p>
      </div>
    </div>
  );
}
